import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { MaterialReactTable } from "material-react-table";
import BookingEditModal from "./BookingEditModal";
import { axiosInstanceWithToken } from "../helpers/axios";
import moment from "moment/moment";
import { getBookingStatusAndStyles } from "@/helpers";
import Swal from "sweetalert2";
import { fDateMoment } from "@/utils/formatDate";

function Trip() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const path = useNavigate();

  useEffect(() => {
    Swal.fire({
      icon: "info",
      text: "Please scroll right and left to view more columns.",
      showConfirmButton: true,
    });
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axiosInstanceWithToken.get("/trip?per_page=10");

        if (response?.data?.status) {
          setData(
            response?.data?.data?.trips.map((trip) => ({
              ...trip,
            }))
          );
          setLoading(false);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const [selectedId, setSelectedId] = useState(null);
  const [isOpen2, setIsOpen2] = useState(false);

  const handleOpenModal = (id) => {
    setSelectedId(id);
    setIsOpen2(true);
  };

  const columns = [
    {
      accessorKey: "id",
      header: "ID",
      size: 150,
    },
    {
      accessorKey: "listing.host.display_name",
      header: "Host",
      size: 150,
      // Cell: ({ row }) => {
      //   const userPicture = row.original.user_picture;
      //   return userPicture ? (
      //     <img src={userPicture} alt="User" style={{ width: "50px", height: "50px" }} />
      //   ) : (
      //     "No Image"
      //   );
      // },
    },
    {
      accessorKey: "created_at",
      header: "Date Created",
      size: 150,
      Cell: ({ row }) => {
        const date = row.original.created_at;
        return date ? moment(date).format("MMM DD YYYY") : "N/A";
      },
    },
    {
      accessorKey: "address",
      header: "Address",
      size: 150,
    },
    {
      accessorKey: "arrival_date",
      header: "Check in",
      size: 150,
      Cell: ({ row }) => {
        const date = row.original.arrival_date;
        return date ? fDateMoment(date) : "N/A";
      },
    },
    {
      accessorKey: "departure_date",
      header: "Check out",
      size: 150,
      Cell: ({ row }) => {
        const date = row.original.departure_date;
        return date ? fDateMoment(date) : "N/A";
      },
    },
    {
      accessorKey: "meta_data.listing_rates.nightly",
      header: "Rent $",
      size: 150,
      Cell: ({ row }) => {
        // console.log(typeof row.original?.meta_data === 'string' ? JSON.parse(row.original?.meta_data) || 0 : row.original?.meta_data)
        return typeof row.original?.meta_data === "string"
          ? JSON.parse(row.original?.meta_data)?.totalNightlyAmount || 0
          : row.original?.meta_data?.totalNightlyAmount;
      },
    },
    {
      accessorKey: "no_of_guests",
      header: "Additional Guests $",
      size: 150,
      Cell: ({ row }) =>
        typeof row.original?.meta_data === "string"
          ? JSON.parse(row.original?.meta_data)?.additionalGuestsPrice || 0
          : row.original?.meta_data?.additionalGuestsPrice,
    },
    {
      accessorKey: "no_of_pets",
      header: "Pet Fee",
      size: 150,
      Cell: ({ row }) =>
        typeof row.original?.meta_data === "string"
          ? JSON.parse(row.original?.meta_data)?.petsPrice || 0
          : row.original?.meta_data?.petsPrice,
    },
    {
      accessorKey: "meta_data.extraServicesPrice",
      header: "Extra Services $",
      size: 150,
      Cell: ({ row }) =>
        typeof row.original?.meta_data === "string"
          ? JSON.parse(row.original?.meta_data)?.extraServicesPrice || 0
          : row.original?.meta_data?.extraServicesPrice,
    },
    {
      accessorKey: "meta_data.totalCleaningFee",
      header: "Cleaning Fee",
      size: 150,
      Cell: ({ row }) =>
        typeof row.original?.meta_data === "string"
          ? JSON.parse(row.original?.meta_data)?.totalCleaningFee || 0
          : row.original?.meta_data?.totalCleaningFee,
    },
    // {
    //   accessorKey: "meta_data.platformFee",
    //   header: "Platform Fee",
    //   size: 150,
    //   Cell: ({ row }) => JSON.parse(row.original?.meta_data)?.totalCityFee || 0,
    // },
    {
      accessorKey: "meta_data.totalAmount",
      header: "Total before taxes",
      size: 150,
      Cell: ({ row }) =>
        typeof row.original?.meta_data === "string"
          ? JSON.parse(row.original?.meta_data)?.totalAmount || 0
          : row.original?.meta_data?.totalAmount,
    },
    {
      accessorKey: "meta_data.taxAmount",
      header: "Taxes",
      size: 150,
      Cell: ({ row }) =>
        typeof row.original?.meta_data === "string"
          ? JSON.parse(row.original?.meta_data)?.taxAmount || 0
          : row.original?.meta_data?.taxAmount,
    },
    {
      accessorKey: "amountAfterTax",
      header: "Total",
      size: 150,
      Cell: ({ row }) =>
        typeof row.original?.meta_data === "string"
          ? JSON.parse(row.original?.meta_data)?.amountAfterTax || 0
          : row.original?.meta_data?.amountAfterTax,
    },
    {
      accessorKey: "status",
      header: "Status",
      size: 150,
      Cell: ({ row }) => {
        const status = row.getValue("status");

        return (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <button
              className={`shadow-md rounded ${
                getBookingStatusAndStyles(status).buttonColor
              } ${getBookingStatusAndStyles(status).textColor}`}
              style={{ padding: "7px 10px" }}
            >
              {getBookingStatusAndStyles(status).label}
            </button>
          </div>
        );
      },
    },
    {
      accessorKey: "actions",
      header: "Actions",
      size: 150,
      Cell: ({ row }) => {
        // const status = row.original.status || "";
        // const isConfirm = status === "pending";
        const carReview = row.getValue("status").toUpperCase() === "COMPLETED";

        const handleAction = (action) => {
          if (action === "View") {
            path("/booking_details", {
              state: { row: row.original, isHost: false },
            });
          } else if (action === "Review") {
            handleOpenModal({
              booking_id: row.original.id,
              listing_id: row?.original?.listing?.id,
            });
          }
        };

        return (
          <div style={{ position: "relative" }}>
            <select
              style={{ fontWeight: "600" }}
              className="shadow-md bg-white cursor-pointer p-[10px] rounded border-soft"
              onChange={(e) => handleAction(e.target.value)}
            >
              <option value="">Select Action</option>
              {/* {isConfirm && <option value="Confirm">Confirm</option>} */}
              {carReview && <option value="Review">Review</option>}
              <option value="View">View</option>
            </select>
          </div>
        );
      },
    },
  ];

  if (loading) {
    return (
      <div className="flex flex-col items-center justify-center h-screen gap-5">
        <img
          className="h-auto w-36 md:w-44" // Responsive sizes
          src="/image/fly-inn-logo.svg"
          alt="Fly Inn Logo"
        />
        <div className="text-2xl text-bold">
          {" "}
          Please Wait while we load your data!
        </div>
      </div>
    );
  }

  return (
    <>
      {isOpen2 && (
        <BookingEditModal
          selectedId={selectedId}
          setIsOpen2={setIsOpen2}
          isOpen2={isOpen2}
          type={"GUEST_TO_BOOKING"}
        />
      )}

      <div className="px-4">
        <div className="dashboard-title text-start">
          <h3>My Trips</h3>
          <h6 className="underline text-start">
            {" "}
            The reviews you leave will be displayed on that listing!
          </h6>
        </div>

        <div className="mt-5">
          <MaterialReactTable
            columns={columns}
            data={data}
            muiPaginationProps={{
              rowsPerPageOptions: [
                { value: 10, label: "10" },
                { value: 25, label: "25" },
                { value: 50, label: "50" },
                { value: 100, label: "100" },
                { value: data.length, label: "All" },
              ],
              showFirstButton: false,
              showLastButton: false,
            }}
            positionActionsColumn="last"
          />
        </div>
      </div>
    </>
  );
}

export default Trip;
